<span class="route-method badge badge--default badge--small">{{ method }}</span>
